import React from 'react';
import { useParams } from 'react-router-dom';
import {
  TrackerFetchActivityConnectorApollo,
  TrackerEditManualActivityConnectorApollo,
  TrackerRemoveActivityConnectorApollo,
  useAppContext,
} from '@front-activerse/common-components';
import TrackerAddEditActivity from '../components/TrackerAddEditActivity';

const EditActivityPage: React.FC = () => {
  const { post } = useAppContext();
  const { date, activityId } = useParams<{ date: string; activityId: string }>();

  if (!date || !activityId) {
    return null;
  }

  const activityIdNum = parseInt(activityId, 10);

  return (
    <TrackerFetchActivityConnectorApollo activityId={activityIdNum}>
      {({ loading, activityData }) => {
        return (
          <TrackerEditManualActivityConnectorApollo post={post}>
            {({ editManualActivity }) => (
              <TrackerRemoveActivityConnectorApollo date={date}>
                {({ removeActivity }) => (
                  <TrackerAddEditActivity
                    editManualActivity={editManualActivity}
                    removeActivity={removeActivity}
                    activityId={activityIdNum}
                    activityData={activityData}
                    loading={loading}
                  />
                )}
              </TrackerRemoveActivityConnectorApollo>
            )}
          </TrackerEditManualActivityConnectorApollo>
        );
      }}
    </TrackerFetchActivityConnectorApollo>
  );
};

export default EditActivityPage;
